var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsignNavLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_140_67",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#F04e45}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1599",
    fill: "none",
    d: "M0 0H23V23H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    fill: "#F04e45",
    d: "M3.886 4.715a.332.332 0 0 1 .353-.333h14.522a.332.332 0 0 1 .353.333v8.556a.331.331 0 0 1-.353.332H4.239a.331.331 0 0 1-.353-.332z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    d: "M19.854 1.938H3.146a1.824 1.824 0 0 0-1.822 1.821v10.468a1.823 1.823 0 0 0 1.822 1.82h5.5l-1.469 3.6H6.15a.706.706 0 0 0-.49.231.7.7 0 0 0-.183.51.707.707 0 0 0 .7.674H16.8a.708.708 0 0 0 .508-1.2.715.715 0 0 0-.516-.215h-.962l-1.47-3.6h5.494a1.823 1.823 0 0 0 1.822-1.82V3.759a1.824 1.824 0 0 0-1.822-1.821zm-5.635 17.709H8.782l1.47-3.6h2.505zM2.739 3.759a.393.393 0 0 1 .407-.407h16.708a.393.393 0 0 1 .407.407v10.468a.393.393 0 0 1-.407.407H3.146a.393.393 0 0 1-.407-.407z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    d: "M4.635 11.379a.633.633 0 0 0 .235.045.564.564 0 0 0 .536-.356 21.474 21.474 0 0 1 1.35-2.756l.105-.183A5.156 5.156 0 0 1 7.828 6.8a18.816 18.816 0 0 0-.105 2.932.549.549 0 0 0 .21.419.57.57 0 0 0 .47.1 4.459 4.459 0 0 0 1.243-.455l-.118.9a.477.477 0 0 0 .236.469.56.56 0 0 0 .588.018l2.057-1.338-.044.869a.5.5 0 0 0 .232.451.594.594 0 0 0 .58.03A7.738 7.738 0 0 1 18 10.437a.577.577 0 0 0 .662-.488.473.473 0 0 0-.4-.57 8.871 8.871 0 0 0-4.764.48l.052-1.047a.523.523 0 0 0-.273-.477.529.529 0 0 0-.552 0l-1.963 1.281.138-1.022a.473.473 0 0 0-.279-.493.573.573 0 0 0-.652.089 3.392 3.392 0 0 1-1.168.8A17.969 17.969 0 0 1 9.032 6a.551.551 0 0 0-.657-.659 3.523 3.523 0 0 0-2.258 1.918 22.262 22.262 0 0 0-1.75 3.486.466.466 0 0 0 .268.634z",
    className: "cls-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsignNavLogoNew);
export default __webpack_public_path__ + "static/media/esignNavLogoNew.a42f56fc4a5807c827708ca4589b69b3.svg";
export { ForwardRef as ReactComponent };